import testimonial_widget_0 from "file:///home/wldocker/wl-cms/sites/modules/testimonial-widget/ui/src/testimonial-widget.js";



import testimonial_widget_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/testimonial-widget/ui/src/testimonial-widget.scss";testimonial_widget_0();